var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36 18A18 18 0 1 1 18 0a18 18 0 0 1 18 18",
    fill: "#ff00b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 23.23s-3.31 4.72-3.33 6.6a.035.035 0 0 1-.01.02 3.335 3.335 0 1 0 6.67 0v-.02c-.03-1.88-3.33-6.6-3.33-6.6m2.34 6.61a.855.855 0 1 1-1.71 0v-.01a.855.855 0 1 1 1.71 0zm13.32-14.56v4h-2.85v1.01h-2.76a10.548 10.548 0 0 1-6.55 6.88V26.1a9.5 9.5 0 1 0-7 0v1.07a10.585 10.585 0 0 1-6.56-6.88H5.18v-1.01H2.34v-4h2.84v-1h2.76a10.49 10.49 0 0 1 20.11 0h2.76v1zM10 14.277h2v4h-2zm5.5 4h-2v-4h2zm3.5 0h-2v-4h2zm3.5 0h-2v-4h2zm3.5 0h-2v-4h2zm-11.5 1.376a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMeter);
export default __webpack_public_path__ + "static/media/water-meter.fbdf75d467562501efde75d1cf527e3c.svg";
export { ForwardRef as ReactComponent };